import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { BookmarkIcon } from '@heroicons/react/24/outline';

import { MenuButtonOption } from 'components/MenuButton';

type SaveAsDefaultRowProps = {
  onSave: () => void;
  // Starts the bottom action group when the Clear row above it isn't shown.
  newGroup?: boolean;
};

export const SaveAsDefaultRow: FC<SaveAsDefaultRowProps> = ({ onSave, newGroup }) => {
  const { t } = useTranslation();

  return (
    <MenuButtonOption
      newGroup={newGroup}
      Icon={BookmarkIcon}
      onClick={onSave}
      testId="filters-menu-save-as-default"
      analyticsId="filters:menu:save-as-default"
    >
      {t('common:components.filters.saveAsDefault')}
    </MenuButtonOption>
  );
};
